export default [
  // {
  //   path: 'demand',
  //   component: () => import('@/views/modules/order/index'),
  //   name: 'demand',
  //   meta: { title: '需求派单', needToken: true },
  //   children: [
  //     {
  //       path: 'createDemand',
  //       component: () => import('@/views/modules/order/orderCreate'),
  //       name: 'createDemand',
  //       meta: { title: '创建需求派单', needToken: true }
  //     }
  //   ]
  // },
  {
    path: 'demandDetail',
    component: () => import('@/views/modules/demandManage/demand-detail'),
    name: 'demandDetail',
    meta: { title: '需求详情', needToken: true }
  }
]
